import { gsap } from "gsap";
import { Container, Point, Sprite } from "pixi.js";

import { getDebugSymbolWithText } from "../../game/utils/ApocalypseGraphicUtils";
import { AbstractSpine } from "../graphics/AbstractSpine";
import { ValueObj } from "../types/interfaces";

export class AbstractSymbol extends Container {
    protected textureFolderPath: string = ``; // the path to textures

    protected mainTextureSprite: Sprite; // the main frame we are showing when symbol is in idle state

    protected mainSpine: AbstractSpine; // the spine containing most of the animations

    protected initialSize: number = 2; // in case the symbol size is changed during features

    protected _size: number = 1; // defines how tall is the symbol. Since a half symbol size is 1, the normal size is 2

    protected _isSpinning: boolean = false; // if the symbol is spinning

    public valueObj: ValueObj = { value: 0 }; // in case a value is needed in different scenarios

    public reelPosition: number = -1; // used to calculate symbols resizing and spin start

    public positionInArray: number = -1; // used to memorize symbol position inside the currentSymbols array of the Reel class

    public isWild: boolean = false; // if the symbol is a wild

    public isBlocked: boolean = false;

    public isActivated: boolean = false;

    public revealedSymbolName: string;

    public get size(): number {
        return this._size;
    }

    public set size(value: number) {
        this._size = value;
    }

    constructor(symbolName: string, size: number) {
        super();

        // setting up the symbol name
        this.name = symbolName;

        // from textureFolderPath we are getting our texture assets
        this.textureFolderPath = this.getTextureFolderPath();

        // size may be needed in various scenarios, like splitting a normal symbol in two halfs
        this.size = size;
        this.initialSize = size;

        this.initializeSpines();

        this.init();
    }

    protected get symbolHeight(): number {
        //this should be overwritten with the actual size in pixels

        return 1;
    }

    protected getTextureFolderPath(): string {
        return this.name.replace(`_HALF`, ``);
    }

    protected initializeSpines(): void {}

    protected init(): void {
        // initializing different stuff like spine files, textures, sprites etc.
    }

    protected generateSymbol(): void {}

    protected generateDebugSymbol(): void {
        //the debug symbol can be used as placeholder until graphics are provided by designers

        this.mainTextureSprite = getDebugSymbolWithText(this.name); //! getDebugSymbol should be moved outside of abstract
        this.addChild(this.mainTextureSprite);
    }

    public replaceMainTextureWithSpine(spine: AbstractSpine): void {
        //switching the main texture with a spine animation

        this.removeChild(this.mainTextureSprite);
        this.addChild(spine);
    }

    public getWinAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return gsap.to({}, {});
    }

    public getRemoveAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return gsap.to({}, {});
    }

    public getWildAnimation(): gsap.core.Tween {
        return gsap.to({}, {});
    }

    public getXNudgeAnimation(): gsap.core.Timeline | gsap.core.Tween {
        return gsap.timeline();
    }

    public getLandingAnimation(): gsap.core.Tween | gsap.core.Timeline {
        return gsap.to({}, {});
    }

    public getSpineGlobalPosition(): Point {
        return this.mainSpine.getGlobalPosition();
    }
    public reset(): void {
        this.resetMainSpine();

        if (this.mainTextureSprite) {
            this.mainTextureSprite.tint = 0xffffff;
            this.mainTextureSprite.alpha = 1;
            this.addChild(this.mainTextureSprite);
        }

        this.alpha = 1;

        this.scale.set(1);

        this.size = this.initialSize;

        this.isWild = false;

        this.isBlocked = false;

        this.isActivated = false;

        this.visible = true;
    }

    public getMainTextureSprite(): Sprite {
        return this.mainTextureSprite;
    }

    protected resetMainSpine(): void {
        if (this.mainSpine !== undefined) {
            this.removeChild(this.mainSpine);
            this.mainSpine.reset();
        }
    }

    public resetOnStartSpin(): void {}
}
